export const ActivityAction = {
    Add: "add_note",
    Filter: "filter_note",
    Edit: "edit_note",
    Highlight: "highlight_note",
    Reply: "reply_note",
    Update: "update_note",
    Delete: "delete_note",
};
export type ActivityActionEnum = $Values<typeof ActivityAction>;
